import { Flow_Parameter__Office__Input } from '~/graphql/types';
import { OfficeParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';
import isNullOfficeParameterValue from './isNullOfficeParameterValue';

export default (
  parameterValue: OfficeParameterValue,
): Flow_Parameter__Office__Input => {
  if (isNullOfficeParameterValue(parameterValue))
    throw new Error(
      `Validation should have caught that the parameterValue ${JSON.stringify(
        parameterValue,
        null,
        2,
      )} value is not identified`,
    );

  switch (parameterValue.type) {
    case PARAMETER_VALUE_TYPE.OFFICE_PRIMITIVE:
      if (parameterValue.value == null) {
        throw new Error(
          `Validation should have caught that the parameterValue ${JSON.stringify(
            parameterValue,
            null,
            2,
          )} value is not identified`,
        );
      }

      return {
        Office: {
          Primitive: {
            value: parameterValue.value,
          },
        },
      };
    case PARAMETER_VALUE_TYPE.OFFICE_POINTER:
      if (
        parameterValue.variable == null ||
        parameterValue.variable.field == null
      ) {
        throw new Error(
          `Validation should have caught that the parameterValue ${JSON.stringify(
            parameterValue,
            null,
            2,
          )} has no field`,
        );
      }

      return {
        Office: {
          Pointer: {
            variable: parameterValue.variable.name,
            field: parameterValue.variable.field.name,
          },
        },
      };
    default:
      throw new Error(
        `OfficeParameterValue value input conversion cannot handle (${JSON.stringify(
          parameterValue,
          null,
          2,
        )})`,
      );
  }
};
